import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import GameActions from '../../../../actions/game/game-actions'
import GameSelectors from '../../../../actions/game/game-selectors'
import MainColCP from '../../../structure/MainColCP'
import Utils from '../../../../common/Utils.js'
import { ReactComponent as BoatIcon } from './assets/boat.svg'
import { ReactComponent as BoatOutlineIcon } from './assets/boat_outline.svg'
import { ReactComponent as FishIcon } from './assets/fish.svg'
import { ReactComponent as FishOutlineIcon } from './assets/fish_outline.svg'
import { ReactComponent as AnchorIcon } from './assets/anchor.svg'
import { ReactComponent as StockIcon } from './assets/stock.svg'
import { ReactComponent as StockOutlineIcon } from './assets/stock_outline.svg'
import { ReactComponent as FactoryIcon } from './assets/factory.svg'
import { ReactComponent as CartIcon } from './assets/cart.svg'
import { ReactComponent as MersonIcon } from './assets/merson.svg'
import { ReactComponent as ArchIcon } from './assets/arch.svg'
import { ReactComponent as ArchOutlineIcon } from './assets/arch_outline.svg'
import { ReactComponent as FenceIcon } from './assets/fence.svg'
import { ReactComponent as LineTL_BR } from './assets/line_tl-br.svg'
import { ReactComponent as LineBL_TR } from './assets/line_bl-tr.svg'
import { ReactComponent as LineL_R } from './assets/line_l-r.svg'
import { ReactComponent as LineV } from './assets/line_v.svg'
import FoldoutCP from '../../../common/displaySchema/FoldoutCP'
import merge from 'deepmerge'
import AnimateState from '../../../../lib/io/BrianCorr/AnimateState.js'
import './TragedyOfTheCommons_style.css'

import AnimNumCP from './AnimNum_CP'
import InventoryCP from './Inventory_CP.jsx'

import NotificationBarCP from '../../generic/NotificationBarCP.jsx'
import DisplaySchema from '../../../common/displaySchema/schemas/DisplaySchema.js'
import DisplayBySchemaCP from '../../../common/displaySchema/DisplayBySchemaCP.jsx'
import DisplayTypes from '../../../common/displaySchema/displayTypes/DisplayTypes.js'

// TODO: once all this is working do a huge clean up and componentize 

// --- utils --- //
function sumObject (obj) {
  return Object.values(obj).reduce((a, b) => a + b, 0)
}

function overlayObj (base, over) {
  if ('object' != typeof over || 'object' != typeof base) return over 
  let merged = Utils.clone(base)
  
  for (const prop in over) {
    merged[prop] = overlayObj(merged[prop], over[prop])
  }
  return merged
}
//window.overlayObj = overlayObj
function getStatesFromDiffs (initState, diffs, toGets) {
  //toGets = Utils.clone(toGets) // we modify this
  let state = Utils.clone(initState)
  let returnStates = []
  for (let i = 0; i < diffs.length; i++) {
    state = overlayObj(state, diffs[i])
    // var tgI = toGets.indexOf(i)
    // if (tgI !== -1) {
    //   // this is one we want so add it to the return and remove it from the get list for faster searching later
    //   toGets.splice(tgI, 1)
    //   returnStates.push(Utils.clone(state))
    // }
    // I decided not to prematurely optomise, but if you want to optomise for long get lists it's up there
    if (toGets.includes(i)) {
      returnStates.push(Utils.clone(state))
    }
  }
  return returnStates
}

// animation eases
function boatMoveEase (pct) {
  return AnimateState.findOnCorrCurve(pct, 0.65, 2.0) // 0.5, 1.5
}

// TODO: make this a bcio component
function makeInfoTable (cols, headerLabels, dataRows, superLabel=null) {
  if (superLabel === null) superLabel = <>&nbsp;</>
  let rows = []
  let rowId = 0
  let colId = 0
  let cells = []

  cells.push(
    <td key={`head_label`}>{superLabel}</td>
  )
  for (colId = 0; colId < cols; colId++) {
    cells.push(
      <th key={`head_${colId}`}>{headerLabels[colId]}</th>
    )
  }
  rows.push(
    <tr key='head'>
      {cells}
    </tr>
  )

  for (rowId = 0; rowId < dataRows.length; rowId++) {
    cells = []
    cells.push(
      <th key={`${rowId}_label`}>{dataRows[rowId].label}</th>
    )
    for (colId = 0; colId < cols; colId++) {
      cells.push(
        <td key={`${rowId}_${colId}`}><AnimNumCP n={dataRows[rowId].data[colId]} /></td>
      )
    }
    rows.push(
      <tr key={rowId}>
        {cells}
      </tr>
    )
  }

  return (
    <table className='bcioInfoTable'>
      <tbody>
        {rows}
      </tbody>
    </table>
  )
}

function formatRealNum (num) {
  return parseFloat(num.toFixed(2))
}

// --- new game form component --- //
export function TragedyOfTheCommons_NewForm_CP (props) {
  function render () {
    let dispMeta = new DisplaySchema({
      displayName: 'Number of VPs',
      displayType: DisplayTypes['NUMBER'].id,
      markupAttributes: {
        style:{
          'width': '3em'
        }, 
        min: 5,
      }
    })

    let val = 9
    if ('maxVPsInPlay' in props.value) val = props.value.maxVPsInPlay
    let objPath = props.objPath + '.maxVPsInPlay'
    
    let pg = (
      <DisplayBySchemaCP objPath={objPath}
        isEditable={true} 
        value={val}
        meta={dispMeta} 
        onChange={props.onChange} 
        omitRootContain={false} />
    )
    return pg
  }

  return render()
}

// --- rules component --- //
export function TragedyOfTheCommons_Rules_CP (props) {
  function render () {
    let vpIcon = <ArchIcon className='TOC_icon_small TOC_dark_icon' style={{'marginTop':'0.6em'}}/>
    let stockIcon = <StockIcon className='TOC_icon_small TOC_dark_icon' style={{'marginTop':'0.6em'}}/>
    // TODO: get this info from game settings
		let canProdTableData = [
      {label:'', data:[1,"$30",0,0]},
      {label:'', data:[2,"$40",1,0.5]},
      {label:'', data:[3,"$60",3,1]},
      {label:'', data:[4,"$80",4,1]},
      {label:'', data:[5,"$100",5,1]},
      {label:'', data:[6,"$130",9,1.5]},
      {label:'', data:[7,"$170",14,2]},
      {label:'', data:[8,"$210",16,2]},
      {label:'', data:[9,"$250",18,2]},
      {label:'', data:[10,"$300",25,2.5]},
      {label:'', data:[11,"$350",33,3]},
      {label:'', data:[12,"$400",36,3]},
      {label:'', data:[13,"$450",39,3]},
    ]

    let canProdTableEle = makeInfoTable (5, ["share","cost","prod","unit$/share"], canProdTableData)

    let pg = <div className='rules-page'>
      <div className='rules-title'>Tragedy of the Commons</div>
      <p>
        You live on an island where fishing is the major industry. Build your fortune by running fishing boats, investing in canneries, and engaging in philanthropy. But be sure to take care of the fish population, the common resource underpinning the entire economy. By predicting the ever shifting market and making shrewd business decisions you can build the largest fishing empire and leave a lasting legacy. 
      </p>
      <div className='rules-header-1'>
        The Island
      </div>
      <p>
        The island has 4 fishing grounds each with a fish market at the port. It has 4 canneries each dedicated to one of the fish markets. It has 2 grocery stores each buying from 2 of the canneries. The population of the island changes with employment and the more people employed the more groceries will be sold. 
      </p>
      <p>
        The island also has a Boat market and a market for building works of public good which will increase quality of life on the island and gain you Victory Points. 
      </p>
      <div className='rules-header-1'>
        Player Moves
      </div>
      <p>
        When submitting moves you may: 
        <ul>
          <li>
            buy and sell Boats
          </li>
          <li>
            invest in and divest from Canneries 
          </li>
          <li>
            buy and sell Victory Points
          </li>
        </ul>
      </p>
      <p>
        You may take as many actions as you can afford. It is common and often most profitable to take no actions at all. All players submit moves secretly, and at the same time.
      </p>
      <p>
        Player orders are fulfilled in the following sequence:
        <ul>
          <li>
            Victory Points are bought and sold.
          </li>
          <li>
            Boats that are being sold or moved, transit to the Marina. <span className="rules-bold">They will not fish this round.</span>
          </li>
          <li>
            Cannery investments and divestments are made.
          </li>
        </ul>
      </p>
      <p>
        Note that all purchases are made before receiving any money from selling or business activities. Meaning <span className="rules-bold">you will need to have cash in hand for all moves of a turn.</span>
      </p>

      <div className='rules-header-1'>
        The Wheels of Industry
      </div>
      <p>
        Then we turn the wheels of industry! Goods are bought, moved, and sold, money is made and lost, and prices adjusted in the following order: 
      </p>
      <p>
        <ul>
          <li>
            For each of the four regions (NW, SW, NE, SE):
            <ul>
              <li>
                The fish population goes down by 1 for each boat.
              </li>
              <li>
                The owner of each boat gains money equal to the going rate for fish at the local port.
              </li>
              <li>
                The cannery produces food by buying fish from the local port and selling it to the local grocer. Profit is made from the difference in price and split evenly between the investors. The more investments in the cannery the more units it will produce per round. 
              </li>
            </ul>
          </li>
          <li>
            The residents of the island then eat. One unit of food is purchased for every two people, rounded up. All food is purchased from the grocer with the lowest price. If there is a tie it will be purchased from the same grocer as the previous round.
          </li>
          <li>
            Then prices are adjusted.
            <ul>
              <li>
                The price of groceries goes down $1 for each unit bought from canneries and goes up $1 for each unit sold. So if a grocer is buying as many units as it's selling the price doesn't change.
              </li>
              <li>  
                The price of fish at the ports is adjusted in the same way. -$1 for each fish brought in, +$1 for each fish sold to the cannery. 
              </li>
              <li>
                Fish population grows +1 for every 4 fish rounded up. (fish population x 1.25) So if you have 10 fish it will grow to 13 fish. 
              </li>
              <li>
                The price of Victory Points is adjusted.
              </li>
              <li>
                The price of Boats is adjusted.
              </li>
            </ul>
          </li>
          <li>
            Then Boats that were in transit arrive at their fishing grounds.
          </li>
        </ul>
      </p>
      <p>
        Then a new turn begins.
      </p>

      <div className='rules-header-1'>
        Game Conclusion
      </div>
      <p>
        The game ends when either 9 Victory Points are sold or the round number/2 is greater than the number of victory points sold. For example if at the end of round 9 only 4 Victory Points are in play the game ends.
      </p>
      <p>
        When the game ends everyone's assets are liquidated and converted to Victory Points, and you all did as well as you did. 
      </p>


      <div className='rules-header-1'>
        Further Explanation
      </div>
      <div className='rules-header-2'>
        Price Adjustment
      </div>
      <p>
        There are two types of markets. What we'll call the commodities markets which are for bulk goods. Those being the fish markets and grocery markets. And non-commodities markets: the Boat market, Victory Point market, and Cannery Investment markets, which are for big ticket items where you're likely buying/selling only 1 or 2 units at a time. 
      </p>
      <p>
        The commodities markets maintain a steady price for the whole round no matter how many units are bought or sold during the round. The price only changes at the end of the round based on the sum total difference in units from the beginning of the round to the end. For example if 5 fish were sold onto a fish market and the cannery only bought 3 fish there are now 2 more fish on the market and the price per fish would go down by $2. 
      </p>
      <p>
        Non-commodities markets are also adjusted at the end of the round but do NOT have a consistent price for each unit in a single player's order. For example, Victory Points increase in price $10 per unit sold. Lets say the current price to buy is $50. If I buy 2 Victory Points I'll pay $50 for the first one and $60 for the second one. It can be pictured as a series of lots increasing in price and containing either a VP or money. When buying you'll exchange money for a VP, when selling you'll exchange a VP for money.    
      </p>
      <p>
        Buy for $50, sell for $40:
        {makeInfoTable (6, [30, 40, 50, 60, 70], [{data:['$','$',vpIcon,vpIcon,vpIcon],label:''}])}
      </p>
      <p>
        Buy for $60, sell for $50:
        {makeInfoTable (6, [30, 40, 50, 60, 70], [{data:['$','$','$',vpIcon,vpIcon],label:''}])}
      </p>
      <p>
        If multiple people buy VPs at the same time each will pay the same market price (adjusted for order size as mentioned above). 
        <br />
        For example in a buy for $50 / sell for $40 market if: 
        <ul>
          <li>
            Ahab is buying 1 VP, 
          </li>
          <li>
            Quint is buying 2 VPs, 
          </li>
          <li>
            Nemo is buying 2 VPs, and 
          </li>
          <li>
            Kurtz is selling 2 VPs 
          </li>
        </ul>
        all on the same turn. 
      </p>
      <p>
        <ul>
          <li>
            Ahab will pay $50
          </li>
          <li>
            Quint will pay $50 + $60
          </li>
          <li>
            Nemo will also pay $50 + $60
          </li>
          <li>
            Kurtz will <span className="rules-bold">GAIN</span> $40 + $30
          </li>
        </ul>
      </p>
      <p>
        Then the market will adjust by +1 +2 +2 -2 = +3 to a buy for $80 / sell for $70 market.
      </p>
      <p>
        This is the same for the Boat market and for investments in a Cannery. No matter what price you invested/bought at, when you divest/sell you get the top price. 
      </p>

      <br />
      <div className='rules-header-2'>
        Cannery Production 
      </div>
      <p>
        Investing in a Cannery not only causes the price of investment to go up, it also allows the cannery to produce more units per round, and for more profit per share. 
      </p>
      <p id='TOCCanProdTable'>
        {canProdTableEle}
      </p>
      <p>
        "Unit$/share" is the percentage of unit profit the Cannery can pay out per share as dividend. For example if the cannery has sold 2 shares it will produce 1 unit and each share will get 50% of the unit profit. Let's say the cost of fish is $2/unit and the cost of groceries is $8/unit, that is a profit of $6 / unit. So each share will get $3. 
      </p>
      <p>
        At 10 investments or more the Cannery will not sell anymore shares. It is possible for multiple players to buy the 10th share. So in the case of a 4 way tie three additional shares would be issued. 
      </p>
      <div className='rules-header-1'>
        Edge Cases and Ties
      </div>
      <div className='rules-header-2'>
        More on Resolving Ties With a Limited Number of Investment Slots Remaining
      </div>
      <p>
        (<span className="rules-bold">This section isn't needed to start playing.</span> It describes an edge case when multiple players want to invest varying amounts in a Cannery that is about to max out.) 
      </p>
      <p>
        Once the 10th share is sold the cannery is closed to any further investment. But players can invest in as many shares as they can afford and it's likely that all players may want to invest in the same cannery at the same time. So we'll include "extra shares" in the case that several players want to invest in the 10th shares. (Number of extra shares = number of players - 1.) So if all 4 players invest in share 10 they will each get a share then investment will be closed until divestment reopens share 10. 
      </p>
      <p>
        Example:
      </p>
      <p>
        Shares 1-4 are sold, shares 5-10 are available. 
        <div className="TOC_stockTable">
          {makeInfoTable (14, [1,2,3,4,5,6,7,8,9,10,11,12,13], [{data:['$','$','$','$',stockIcon,stockIcon,stockIcon,stockIcon,stockIcon,stockIcon,stockIcon,stockIcon,stockIcon],label:''}, {data:['','','','','↑'],label:''}])}
        </div>
      </p>
      <p>
        And let's say all 4 players buy in at the same time:
        <ul>
          <li>
            Ahab wants 2
          </li>
          <li>
            Quint wants 1
          </li>
          <li>
            Nemo wants 4
          </li>
          <li>
            Kurtz wants 3
          </li>
        </ul>
        So we do this in rounds, everyone wants at least 1 so each player pays the #5 price and is given a share. 
        <br />
        We then increment the price to the #6 cost. Keep in mind each player did not know if others would invest so each player that wants a second investment pays as if they were the only ones buying.
      </p>
      <p>
        <div className="TOC_stockTable">
          {makeInfoTable (14, [1,2,3,4,5,6,7,8,9,10,11,12,13], [{data:['$','$','$','$','$','$','$','$',stockIcon,stockIcon,stockIcon,stockIcon,stockIcon],label:''}, {data:['','','','','','↑'],label:''}])}
        </div>
        We check the last share, #10, and it is still available so we then check if anyone wanted a second investment.  
        <br />
        Turns out 3 players wanted at least a second investment so we charge the #6 price from each, give all three players a share, then increment the price to the #7 cost.
      </p>
      <p>
        <div className="TOC_stockTable">
          {makeInfoTable (14, [1,2,3,4,5,6,7,8,9,10,11,12,13], [{data:['$','$','$','$','$','$','$','$','$','$','$',stockIcon,stockIcon],label:''}, {data:['','','','','','','↑'],label:''}])}
        </div>
        There are still more orders so we check if the #10 share is still available and it is NOT so we can not fulfill any more orders. So Nemo and Kurtz don't get their full order BUT the available shares were distributed fairly. 
      </p>
      <p>
        After 2 divestments share #10 will be available and players will be able to invest again. 
      </p>
      <p>
        <br /><br /><br />
      </p>
    </div>
    return pg
  }

  return render()
}

// --- history component --- //
export function TragedyOfTheCommons_Hist_CP (props) {
  // TODO: implement a proper enforced interface
  // props should be: { moveHistory, playerDict, phaseId, stateChangeHistory, initState }
  // game.gameState.init_state.player_state
  function render() {

    // let phaseId = props.phaseId
    // let stateChangeHistory = [props.initState].concat(props.stateChangeHistory) // include init state as 0th
    // if (phaseId >= stateChangeHistory.length-1) return (<></>)

    let rows = []
    let lastPhaseId = props.stateChangeHistory.length - 1
    let prevState = props.initState
    for (let phaseId=0; phaseId<props.stateChangeHistory.length; phaseId++) {
      let diff = props.stateChangeHistory[phaseId]
      //console.log(diff)
      let nowState = merge(prevState, diff)

      let phase = props.moveHistory[phaseId]
      let isLast = (phaseId === lastPhaseId)
      let actionRows = []
      Object.keys(phase).forEach(userId => {
        actionRows.push(renderPlayerRow(userId, prevState, nowState))
      })

      rows.push(
        <div className='move-hist-padded' key={phaseId}>
          <FoldoutCP displayName={phaseId+1} isOpen={isLast}>
            {actionRows}
          </FoldoutCP>
        </div>
      )

      prevState = nowState
    }
    return rows
  }

  function formatDiff (diff, symbol='') {
    if (diff === 0) return `${symbol}•` //'○'
    if (diff < 0) return `-${symbol}${Math.abs(diff)}`
    if (diff > 0) return `+${symbol}${diff}`
  }

  function renderPlayerRow(userId, prevState, nowState) {
    let moneyDiff = nowState.player_state[userId].money - prevState.player_state[userId].money
    let vpDiff = nowState.player_state[userId].vpCount - prevState.player_state[userId].vpCount
    moneyDiff = formatDiff(formatRealNum(moneyDiff), '$')
    vpDiff = formatDiff(vpDiff)
    let headerLabels = []
    let dataRows = []
    headerLabels.push(
      <BoatIcon className='TOC_icon_small TOC_dark_icon' />
    )
    headerLabels.push(
      <StockIcon className='TOC_icon_small TOC_dark_icon' />
    )
    portNames.forEach(portId => {
      let boatDiff = nowState.player_state[userId].boatsByLocation[portId] - prevState.player_state[userId].boatsByLocation[portId]
      let investDiff = nowState.player_state[userId].investByLocation[portId] - prevState.player_state[userId].investByLocation[portId]
      boatDiff = formatDiff(boatDiff)
      investDiff = formatDiff(investDiff)
      dataRows.push({
        'label': portId.toUpperCase(),
        'data': [boatDiff, investDiff],
      })
    })

    let infoTable = makeInfoTable(2, headerLabels, dataRows)

    return (
      <div className='move-hist-action' key={userId}>
        <div className='move-hist-action-player-name' style={{color: props.playerDict[userId].color}}>
          {props.playerDict[userId].name}
        </div>
        <div className='move-hist-action-player-move'>
          <div className='TOC_player_col_body'>
            <div>{moneyDiff}&nbsp;&nbsp;<ArchIcon className='TOC_icon_small TOC_byline_icon TOC_dark_icon' />{vpDiff}</div>
            <div>
              {infoTable}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return render()
} 


// --- x --- //


let portNames = ['nw', 'sw', 'ne', 'se']

// --- HTML groups, even more simple than dumb-components (see what I did there?) --- //
// - diagonal arrows - 
let ArrowComp_TL_BR = (
  <>
    <LineTL_BR className='TOC_diag_line' />
    <div className="TOC_diag_line_sm" style={{rotate: '30deg'}}>
      <LineTL_BR className='TOC_diag_line' />
    </div>
    <div className="TOC_diag_line_sm" style={{rotate: '-30deg'}}>
      <LineTL_BR className='TOC_diag_line' />
    </div>
  </>
)
let ArrowsComp_TL_BR = (
  <>
    <div className='TOC_abs_seg' style={{left: '0', right: '60%', top: '0', bottom: '60%'}}>
      {ArrowComp_TL_BR}
    </div>
    <div className='TOC_abs_seg' style={{left: '60%', right: '0', top: '60%', bottom: '0'}}>
      {ArrowComp_TL_BR}
    </div>
  </>
)

let ArrowsComp_BR = (
  <div className='TOC_arrows_BR'>
    {ArrowsComp_TL_BR}
  </div>
)

let ArrowsComp_TL = (
  <div className='TOC_arrows_TL'>
    {ArrowsComp_TL_BR}
  </div>
)

// - 

let ArrowComp_BL_TR = (
  <>
    <LineBL_TR className='TOC_diag_line' />
    <div className="TOC_diag_line_sm" style={{rotate: '30deg'}}>
      <LineBL_TR className='TOC_diag_line' />
    </div>
    <div className="TOC_diag_line_sm" style={{rotate: '-30deg'}}>
      <LineBL_TR className='TOC_diag_line' />
    </div>
  </>
)
let ArrowsComp_BL_TR = (
  <>
    <div className='TOC_abs_seg' style={{left: '0', right: '60%', top: '60%', bottom: '0'}}>
      {ArrowComp_BL_TR}
    </div>
    <div className='TOC_abs_seg' style={{left: '60%', right: '0', top: '0', bottom: '60%'}}>
      {ArrowComp_BL_TR}
    </div>
  </>
)

let ArrowsComp_BL = (
  <div className='TOC_arrows_BL'>
    {ArrowsComp_BL_TR}
  </div>
)

let ArrowsComp_TR = (
  <div className='TOC_arrows_TR'>
    {ArrowsComp_BL_TR}
  </div>
)

// - straight arrows 

let ArrowComp_V = (
  <>
    <LineV className='TOC_diag_line' />
    <div className="TOC_diag_line_sm" style={{rotate: '30deg'}}>
      <LineV className='TOC_diag_line' />
    </div>
    <div className="TOC_diag_line_sm" style={{rotate: '-30deg'}}>
      <LineV className='TOC_diag_line' />
    </div>
  </>
)
let ArrowComp_L_R = (
  <>
    <LineL_R className='TOC_diag_line' />
    <div className="TOC_diag_line_sm" style={{rotate: '30deg'}}>
      <LineL_R className='TOC_diag_line' />
    </div>
    <div className="TOC_diag_line_sm" style={{rotate: '-30deg'}}>
      <LineL_R className='TOC_diag_line' />
    </div>
  </>
)
let ArrowsComp_L_R = (
  <>
    <div className='TOC_abs_seg' style={{left: '0', right: '60%', top: '0', bottom: '0'}}>
      {ArrowComp_L_R}
    </div>
    <div className='TOC_abs_seg' style={{left: '60%', right: '0', top: '0', bottom: '0'}}>
      {ArrowComp_L_R}
    </div>
  </>
)

let ArrowsComp_R = (
  <div className='TOC_arrows_R'>
    {ArrowsComp_L_R}
  </div>
)

let ArrowsComp_L = (
  <div className='TOC_arrows_L'>
    {ArrowsComp_L_R}
  </div>
)

let ArrowsComp_Up = (
  <div className='TOC_arrows_Up'>
    {ArrowComp_V}
  </div>
)



// ============ * ============ //

class TragedyOfTheCommons_CP extends Component {
  constructor (props) {
    super(props)

    // - animation refs - //

    let transitIds = portNames.concat([]) // clone

    this.animEle = {
      'fish':{},
      'prod':{},
      'boat':{},
      'cons':{
        'w': createRef(),
        'e': createRef(),
      }, 
      'pop':{}
    }
    for (let portId of transitIds) {
      this.animEle.fish[portId] = createRef()
      this.animEle.prod[portId] = createRef()
    }

    let initAnimBoat = {}
    transitIds = transitIds.concat(['buy']) // add a categopry
    for (let portId of transitIds) {
      this.animEle.boat[portId] = {}
      initAnimBoat[portId] = {}
      for (let player of props.gamePlayerList) {
        this.animEle.boat[portId][player.id] = createRef()
        initAnimBoat[portId][player.id] = 0
      }
    }

    this.playerDict = {}
    let initMarina = {}
    for (let player of props.gamePlayerList) {
      initMarina[player.id] = 0
      this.playerDict[player.id] = player
    }
    
    //this.noteCP = new NotificationBarCP()
    this.noteCP = createRef()

    // pop animation elements
    this.animEle.pop = {}
    this.animEle.pop.vpPrice = createRef()
    this.animEle.pop.boatPrice = createRef()
    this.animEle.pop.fish_nw = createRef()
    this.animEle.pop.fish_sw = createRef()
    this.animEle.pop.fish_ne = createRef()
    this.animEle.pop.fish_se = createRef()
    this.animEle.pop.invest_nw = createRef()
    this.animEle.pop.invest_sw = createRef()
    this.animEle.pop.invest_ne = createRef()
    this.animEle.pop.invest_se = createRef()
    this.animEle.pop.investPrice_nw = createRef()
    this.animEle.pop.investPrice_sw = createRef()
    this.animEle.pop.investPrice_ne = createRef()
    this.animEle.pop.investPrice_se = createRef()
    this.animEle.pop.label_nw = createRef()
    this.animEle.pop.label_sw = createRef()
    this.animEle.pop.label_ne = createRef()
    this.animEle.pop.label_se = createRef()
    //this.animEle.pop. = createRef()

    // TODO: this is a bit ad-hoc
    //   at least make in boat.nw.playerId
    this.popKeys = ['vp', 'boat_transit', 'player_name']
    for (let portId of portNames) {
      this.popKeys.push(`invest_${portId}`)
      this.popKeys.push(`boat_${portId}`)
    }

    for (let eleKey of this.popKeys) {
      for (let player of props.gamePlayerList) {
        let key = `${eleKey}_${player.id}`
        this.animEle.pop[key] = createRef()
      }
    }
    this.animEle.pop['player_name_run_ecconomy'] = createRef() // Good jebus ABSTRACT THIS!

    this.priceRowCount = 4 // 6

    this.initInputState = Object.freeze({
      // user actions
      actions: {}, // change set
      spend: 0,
      gain: 0,
    })

    this.state = {
      isAnimating: false,
      input: Utils.clone(this.initInputState),
      gameState: props.gameState,
      uiState: {
        inventory: {
          'w': 0,
          'e': 0,
          'nw': 0,
          'sw': 0,
          'ne': 0,
          'se': 0,
          'vp': 0,
          'boat': 0,
        },
        marina: initMarina,
        anim: { // TODO: put these values into the HTML 
          fish: {
            'nw': 0,
            'sw': 0,
            'ne': 0,
            'se': 0,
          },
          prod: {
            'nw': 0,
            'sw': 0,
            'ne': 0,
            'se': 0,
          },
          boat: initAnimBoat,
          consumption: 0,
        }
      }
    }

    window.testAnim = this.testAnim
    window.testPop = this.testPop
  }

  canUserEdit () {
    return !(this.state.isAnimating || this.props.isGameOver)
  }

  // --- actions --- //
  // setCanUserEdit (canUserEdit) {
  //   console.log(' ==== setCanUserEdit:', canUserEdit)
  //   this.setState((state) => {
  //     state.canUserEdit = canUserEdit
  //     return state
  //   })
  // }

  // - price calc - //
  priceByAmount (amount, inPlay, priceFunc) {
    let cost = 0
    let debt_mult = 1
    let from_i = inPlay
    let to_i = inPlay + amount
    if (to_i < from_i){
      from_i = to_i
      to_i = inPlay
      debt_mult = -1
    }

    for (let i=from_i; i<to_i; i++){
      cost += priceFunc(i)
    }

    cost = cost * debt_mult
    return cost
  }

  // sent as lambdas so we use => to keep scope

  vpPriceByIndex = (i) => {
    return (i * this.props.settings.costChangePerVP) + this.props.settings.startingVPCost
  }

  boatPriceByIndex = (i) => {
    return (i * this.props.settings.costChangePerBoat) + this.props.settings.startingBoatCost
  }

  investPriceByIndex = (i) => {
    if (i < 0) return 0
    let endI = this.props.settings.investTable.length - 1
    if (i > endI) i = endI
    return this.props.settings.investTable[i].price
  }

  unitPerShareByIndex = (shareCount) => {
    if (shareCount <= 0) return 0
    return this.props.settings.investTable[shareCount].production / shareCount
  }

  // - 

  getVPCost (amount, inPlay){
    if (typeof inPlay === "undefined") {
      inPlay = this.state.gameState.derived.vpsInPlay
    }
    return this.priceByAmount(amount, inPlay, this.vpPriceByIndex)
  }

  getBoatCost (amount, inPlay){
    if (typeof inPlay === "undefined") {
      inPlay = this.state.gameState.derived.boatsInPlay
    }
    return this.priceByAmount(amount, inPlay, this.boatPriceByIndex)
  }

  getInvestCost (portId, amount, inPlay){
    if (typeof inPlay === "undefined") {
      inPlay = this.state.gameState.derived.stocksInPlay[portId]
    }
    return this.priceByAmount(amount, inPlay, this.investPriceByIndex)
  }

  // --- //

  cleanActions (actions) {
    // Note: this functions assumes type of actions: Dict( Dict(number) )
    let cleaned = {}
    for (let actionKey in actions){
      cleaned[actionKey] = {}
      for (let propKey in actions[actionKey]){
        if (0 !== actions[actionKey][propKey]) {
          cleaned[actionKey][propKey] = actions[actionKey][propKey]
        }
      }
      if ( 0 === Object.keys(cleaned[actionKey]).length ) delete cleaned[actionKey]
    }
    return cleaned
  }

  updateActions (newInputState) {
    let spend = 0
    let gain = 0
    // do the money calc
    let boatDiff = 0
    for (let portId in newInputState.boats){
      boatDiff += newInputState.boats[portId]
    }
    // let boatsInPlay = this.state.gameState.derived.boatsInPlay
    // let boatCost = -this.priceByAmount(boatsInPlay, boatDiff, i => this.boatPriceByIndex(i))
    let boatCost = -this.getBoatCost(boatDiff)
    if (boatCost < 0) spend += boatCost
    else gain += boatCost

    if (newInputState.actions?.UPDATE_VPS?.amount) {
      let vpChange = newInputState.actions.UPDATE_VPS.amount
      // let vpsInPlay = this.state.gameState.derived.vpsInPlay
      // let vpCost = -this.priceByAmount(vpsInPlay, vpChange, i => this.vpPriceByIndex(i))
      let vpCost = -this.getVPCost(vpChange)
      if (vpCost < 0) spend += vpCost
      else gain += vpCost
    }

    let investActions = [
      {
        actionName: 'UPDATE_INVEST_NW',
        portId: 'nw',
      },
      {
        actionName: 'UPDATE_INVEST_NE',
        portId: 'ne',
      },{
        actionName: 'UPDATE_INVEST_SW',
        portId: 'sw',
      },{
        actionName: 'UPDATE_INVEST_SE',
        portId: 'se',
      },
    ]
    for (let investAction of investActions) {
      let actionName = investAction.actionName
      if (newInputState.actions?.[actionName]?.amount) {
        let portId = investAction.portId
        let change = newInputState.actions[actionName].amount
        // let inPlay = this.state.gameState.derived.stocksInPlay[portId]
        // let cost = -this.priceByAmount(inPlay, change, i => this.investPriceByIndex(i))
        let cost = -this.getInvestCost(portId, change)
        if (cost < 0) spend += cost
        else gain += cost
      }
    }

    newInputState.spend = spend
    newInputState.gain = gain
    newInputState.actions = this.cleanActions(newInputState.actions)
    this.setState({...this.state, input: newInputState})
  }

  sendActions () {
    if (!this.canUserEdit()) return
    let actions = Utils.clone(this.state.input.actions)
    console.log(actions)
    this.props.submitMove(actions)
    // should only happen on new phase
    //this.resetInputState()
  }

  resetInputState () {
    this.setState( {...this.state, input: Utils.clone(this.initInputState)} )
  }

  updateVPs (amount) {
    if (!this.canUserEdit()) return
    let newInputState = Utils.clone(this.state.input)
    newInputState.actions['UPDATE_VPS'] = {amount}
    this.updateActions(newInputState)
  }

  updateInvest (amount, portId) {
    if (!this.canUserEdit()) return
    let action = null
    switch (portId) {
      case 'nw':
        action = 'UPDATE_INVEST_NW'
        break
      case 'ne':
        action = 'UPDATE_INVEST_NE'
        break
      case 'se':
        action = 'UPDATE_INVEST_SE'
        break
      case 'sw':
        action = 'UPDATE_INVEST_SW'
        break
    }
    if (!action) return

    let newInputState = Utils.clone(this.state.input)
    newInputState.actions[action] = {amount}
    this.updateActions(newInputState)
  }

  updateBoats (amount, portId) {
    if (!this.canUserEdit()) return
    let newInputState = Utils.clone(this.state.input)
    if (!('UPDATE_BOATS' in newInputState.actions)) {
      newInputState.actions['UPDATE_BOATS'] = {}
    }
    newInputState.actions['UPDATE_BOATS'][portId] = amount
    this.updateActions(newInputState)
  }

  // --- view render --- //

  // TODO: make this a BCIO component
  makeIncrimentor (amount, setterFn) {
    let sign = ''
    if (amount > 0) sign = '+'
    return (
      <div className='TOC_num-incr'>
        <button className='bcioButton bcioBtnSm' disabled={!this.canUserEdit()} role='' 
          onClick={() => setterFn(amount-1)} 
        >-</button>
        <div className='bcioNumIncDisp' >&nbsp;{sign}{amount}&nbsp;</div>
        <button className='bcioButton bcioBtnSm' disabled={!this.canUserEdit()} role='' 
          onClick={() => setterFn(amount+1)} 
        >+</button>
      </div>
    )
  }

  makePlayersEndGameViews (gamePlayerList, gameState, final) {
    let playerViews = []
    let playersById = {}
    // playerList to dict
    for (let player of gamePlayerList) {
      playersById[player.id] = player
    }
    // order final by VP, money
    let finalList = []
    for (let playerId in final) {
      finalList.push({
        label: playerId,
        data: final[playerId]
      })
    }
    finalList.sort((a, b) => {
      let sortDir = b.data.vpCount - a.data.vpCount
      if (sortDir === 0) sortDir = b.data.money - a.data.money
      return sortDir
    })
    for (let i = 0; i < finalList.length; i++) {
      let player = playersById[finalList[i].label]
      let playerFinal = finalList[i].data
      let playerState = Utils.clone(gameState.player_state[player.id])
      playerState.money = playerFinal.money
      playerState.vpCount = playerFinal.vpCount
      playerViews.push( this.makePlayerStateView(player, playerState, true) )
    }
    
    return playerViews
  }

  makePlayerStateView (player, playerState, isGameOver=false) {
    let headerLabels = []
    let dataRows = []
    headerLabels.push(
      <BoatIcon className='TOC_icon_small' />
    )
    headerLabels.push(
      <StockIcon className='TOC_icon_small' />
    )
    portNames.forEach(portId => {
      dataRows.push({
        'label': portId.toUpperCase(),
        'data': [ playerState.boatsByLocation[portId], playerState.investByLocation[portId] ],
      })
    })

    // TODO: this and makePlayersEndGameViews should be abstracted
    let header = <></>;
    if (isGameOver) {
      header = <div className="TOC_player_end_game_header"><ArchIcon className='TOC_icon_small TOC_byline_icon' /><AnimNumCP n={playerState.vpCount} />&nbsp;&nbsp;$<AnimNumCP n={formatRealNum(playerState.money)} /></div>
    } else {
      header = <div>$<AnimNumCP n={formatRealNum(playerState.money)} />&nbsp;&nbsp;<ArchIcon className='TOC_icon_small TOC_byline_icon' /><AnimNumCP n={playerState.vpCount} /></div>
    }

    let infoTable = makeInfoTable(2, headerLabels, dataRows)
    // TODO: some repeat code here and in makePlayerStateActionView
    return (
      <div className='TOC_player_col' key={player.id}>
        <div style={{color: player.color}}><b>{player.name}</b></div>
        <div className='TOC_player_col_body'>
          {header}
          <div>
            {infoTable}
          </div>
        </div>
      </div>
    )
  }

  makePlayerStateActionView (player, playerState) {
    let totalSpend = 0
    let totalProfit = 0
    let totalBoatChange = 0
    let boatChangeData = []
    let investChangeData = []
    portNames.forEach(portId => {
      let portId_CAPS = portId.toUpperCase()

      let boatCount = playerState.boatsByLocation[portId]
      let boatChange = this.state.input.actions?.['UPDATE_BOATS']?.[portId] || 0
      let newBoatCount = boatCount + boatChange
      totalBoatChange += boatChange

      let investCount = playerState.investByLocation[portId]
      let investChange = this.state.input.actions?.[`UPDATE_INVEST_${portId_CAPS}`]?.amount || 0
      let newInvestCount = investCount + investChange
      //let investCost = -this.priceByAmount(this.state.gameState.derived.stocksInPlay[portId], investChange, i => this.investPriceByIndex(i))
      let investCost = -this.getInvestCost(portId, investChange)
      if (investCost < 0) {
        totalSpend += investCost
      } else {
        totalProfit += investCost
      }

      boatChangeData.push({
        'label': portId_CAPS,
        'data': [ playerState.boatsByLocation[portId], newBoatCount ],
      })
      investChangeData.push({
        'label': portId_CAPS,
        'data': [ investCount, newInvestCount, investCost ],
      })
    })

    //let boatCost = -this.priceByAmount(this.state.gameState.derived['boatsInPlay'], totalBoatChange, i => this.boatPriceByIndex(i))
    let boatCost = -this.getBoatCost(totalBoatChange)
    if (boatCost < 0) {
      totalSpend += boatCost
    } else {
      totalProfit += boatCost
    }

    let boatIconEle = <BoatIcon className='TOC_icon_small' />
    let stockIconEle = <StockIcon className='TOC_icon_small' />
    let archIconEle = <ArchIcon className='TOC_icon_small' />

    let vpChange = this.state.input.actions?.UPDATE_VPS?.amount || 0
    // let vpsInPlay = this.state.gameState.derived.vpsInPlay
    // let vpCost = -this.priceByAmount(vpsInPlay, vpChange, i => this.vpPriceByIndex(i))
    let vpCost = -this.getVPCost(vpChange)
    if (vpCost < 0) {
      totalSpend += vpCost
    } else {
      totalProfit += vpCost
    }
    let newVPCount = playerState.vpCount + vpChange
    let vpChangeData = [{
      'label': archIconEle,
      'data': [playerState.vpCount, newVPCount],
    }]


    return (
      <div className='TOC_player_col' key={player.id}>
        <div style={{color: player.color}}><b>{player.name}</b></div>
        <div className='TOC_player_col_body'>
          <div>${formatRealNum(playerState.money)}&nbsp;&nbsp;<ArchIcon className='TOC_icon_small TOC_byline_icon' />{playerState.vpCount}</div>
          
          <div>
            {makeInfoTable(2, ['at', 'to'], boatChangeData, boatIconEle)}
          </div>
          <div style={{'paddingLeft': '3.0em', 'marginBottom': '1.0em'}}>
            Σ {totalBoatChange} ${boatCost}
          </div>
          <div>
            {makeInfoTable(3, ['at', 'to', <div style={{minWidth: '3.0em'}}>$</div>], investChangeData, stockIconEle)}
          </div>
          <div>
            {makeInfoTable(2, ['at', 'to'], vpChangeData)}
          </div>
          <div style={{'paddingLeft': '3.0em', 'marginBottom': '1.0em'}}>
            ${vpCost}
          </div>
          <div>
            <div>${formatRealNum(playerState.money)}</div>
            <div>-${-totalSpend}</div>
            <div>+${totalProfit}</div>
            <div>= ${formatRealNum(playerState.money + totalSpend + totalProfit)}</div>
          </div>
          <div>
            <button className='bcioButton' role='' 
              onClick={() => this.resetInputState()} 
            >Reset</button>
          </div>
          <div>
            <button className='bcioButton' disabled={!this.canUserEdit()} role='' 
              onClick={() => this.sendActions()} 
            >Send Orders</button>
          </div>
        </div>
      </div>
    )
  }

  renderPlayerRows (IconCP, eleLambda, eleKey, showAll = false) {
    let rows = []
    this.props.gamePlayerList.forEach(player => {
      //let count = countLambda(this.state.gameState.player_state[player.id])
      let key = `${eleKey}_${player.id}`
      let rowEle = eleLambda(player.id)
      if (showAll || rowEle !== null) {
        rows.push(
          <div ref={this.animEle.pop[key]} className='TOC_info_line' key={key}>
            <IconCP className='TOC_icon' style={{'fill': `${player.color}`}} />: {rowEle}</div>
        )
      }
    })
    return rows
  }
  // prefix for the above function
  renderPlayerCountRows (IconCP, countLambda, eleKey, showAll = false) {
    let eleLambda = playerId => {
      let count = countLambda(playerId)
      if (showAll || count !== 0) {
        return (<AnimNumCP n={count} />)
      }
      return null
    }
    return this.renderPlayerRows (IconCP, eleLambda, eleKey, showAll)
  }

  renderBoatRows (portId) {
    let countLambda = playerId => this.state.gameState.player_state[playerId].boatsByLocation[portId]
    return this.renderPlayerCountRows(BoatIcon, countLambda, `boat_${portId}`)
  }

  renderBoatTransitRows () {
    let countLambda = playerId => this.state.uiState.marina[playerId]
    return this.renderPlayerCountRows(BoatIcon, countLambda, `boat_transit`)
  }

  renderInvestRows (portId) {
    let countLambda = playerId => this.state.gameState.player_state[playerId].investByLocation[portId]
    return this.renderPlayerCountRows(StockIcon, countLambda, `invest_${portId}`)
  }

  renderVPRows () {
    let eleLambda = playerId => {
      let playerState = this.state.gameState.player_state[playerId]
      return ( 
        <>
          <AnimNumCP key='vps' n={playerState.vpCount} />, $<AnimNumCP key='money' n={formatRealNum(playerState.money)} />
        </>
      )
    }
    return this.renderPlayerRows(ArchIcon, eleLambda, `vp`, true)
  }

  // --- 

  renderInvestProdRow (shareCount) {
    if (shareCount <= 0) return <>Closed</>
    let unitPerShare = this.unitPerShareByIndex(shareCount)
    return (
      <>
        Prod: {this.props.settings.investTable[shareCount].production}<CartIcon className='TOC_icon_small' />, {unitPerShare}/<StockIcon className='TOC_icon_small' />
      </>
    )
  }

  getMarketForPort (portId) {
    return portId.slice(-1)
  }

  getDollarPerUnit (portId) {
    let marketId = this.getMarketForPort(portId)
    let perUnit = this.state.gameState.foodPrice[marketId] - this.state.gameState.fishPrice[portId]
    return perUnit
  }

  renderInvestLevelRows (portId) {
    //let marketName = portId.slice(-1)
    //let shareCount = this.state.gameState.derived[`${portId}StockInPlay`]
    let shareCount = this.state.gameState.derived.stocksInPlay[portId]
    let unitPerShare = this.unitPerShareByIndex(shareCount)
    //let perUnit = this.state.gameState.foodPrice[marketName] - this.state.gameState.fishPrice[portId]
    let perUnit = this.getDollarPerUnit(portId)
    let perShare = perUnit * unitPerShare
    let marginRows = (
      <>
        <div className='TOC_info_line'>
          ${perUnit}/<CartIcon className='TOC_icon_small' />
        </div>
        <div className='TOC_info_line'>
          ${perShare}/<StockIcon className='TOC_icon_small' />
        </div>
      </>
    )
    
    let rows = []
    let fromI = shareCount - Math.floor(this.priceRowCount * 0.5)
    if (fromI < 0) fromI = 0
    let toI = fromI + this.priceRowCount + 1 // 
    for (let i=toI-1; i>=fromI; i--) { // higher numbers at top
      let rowShareCount = i
      let rowDiff = i - shareCount
      if (0 > rowDiff) {
        // sell rows
        rows.push(
          <div className='TOC_info_line' key={`stockrow_${rowDiff}`}>
            {rowDiff}<StockOutlineIcon className='TOC_icon_small TOC_icon_outline' /> +${this.investPriceByIndex(rowShareCount)}: {this.renderInvestProdRow(rowShareCount)}
          </div>
        )
      } else if (0 < rowDiff) {
        // buy rows
        rows.push(
          <div className='TOC_info_line' key={`stockrow_${rowDiff}`}>
            +{rowDiff}<StockIcon className='TOC_icon_small' /> -${this.investPriceByIndex(rowShareCount-1)}: {this.renderInvestProdRow(rowShareCount)}
          </div>
        )
      } else {
        // at row
        let rowStyle = {
          margin: '0.4em 0', 
          fontWeight: 'bold', 
          textAlign: 'right',
        }
        if (0 === shareCount) {
          // if it's currently closed, center the closed marker and remove the v-margins
          //  TODO: replace this with classnames
          rowStyle.textAlign = 'center'
          delete rowStyle.margin
        }
        rows.push(
          <div className='TOC_info_line' key={`stockrow_${rowDiff}`} style={rowStyle}> 
            {this.renderInvestProdRow(rowShareCount)}
          </div>
        )
      }
    }
    let popKey = `investPrice_${portId}`
    let prodRows = (
      <div ref={this.animEle.pop[popKey]} className='TOC_align_L'>
        {rows}
      </div>
    )

    return {prodRows, marginRows}
  }

  renderPriceRows (nInPlay, priceByIndexLambda, IconCP, OutlineIconCP) {
    let rows = []
    let fromI = nInPlay - Math.floor(this.priceRowCount * 0.5)
    if (fromI < 0) fromI = 0
    let toI = fromI + this.priceRowCount
    for (let i=toI-1; i>=fromI; i--) { // higher numbers at top
      let price = priceByIndexLambda(i)
      // remember i is 0 indexed
      if (i>=nInPlay) { 
        // buy 
        let amount = (i+1)-nInPlay
        rows.push(
          <div className='TOC_info_line' key={`pricerow_${i}`}>
            <div className='numCol'>+{amount}</div> <IconCP className='TOC_icon_small' /><div className='numCol fourDigit'>-${price}</div>
          </div>
        )
      } else {
        // sell
        let amount = nInPlay-i
        rows.push(
          <div className='TOC_info_line' key={`pricerow_${i}`}>
            <div className='numCol'>-{amount}</div> <OutlineIconCP className='TOC_icon_small TOC_icon_outline' /><div className='numCol fourDigit'>+${price}</div>
          </div>
        )
      }
    }
    return rows
  }

  renderVPPrices () {
    return this.renderPriceRows(
      this.state.gameState.derived.vpsInPlay,
      this.vpPriceByIndex,
      ArchIcon,
      ArchOutlineIcon
    )
  }

  renderBoatPrices () {
    return this.renderPriceRows(
      this.state.gameState.derived.boatsInPlay,
      this.boatPriceByIndex,
      BoatIcon,
      BoatOutlineIcon
    )
  } 

  getGrocerToSell (gameState) {
    let grocerToSell = gameState.lastActiveMarket
    if (gameState.foodPrice.w < gameState.foodPrice.e) grocerToSell = 'w'
    if (gameState.foodPrice.e < gameState.foodPrice.w) grocerToSell = 'e'
    return grocerToSell
  }

  getConsumption (gameState) {
    let consumption = Math.ceil(gameState.derived.employment * this.props.settings.consumptionOverEmployment)
    return consumption
  }

  // ---

  render () {
    //console.log('--- TOC render ---', this)
    if (!this.props.gamePlayerList.length || !this.props?.gameState || !this.state.gameState) return <></>
    let gameState = this.state.gameState
    let uiState = this.state.uiState
    let settings = this.props.settings
    let playerViews = []
    let thisPlayerView = null

    if (this.props.isGameOver && !this.state.isAnimating) {
      playerViews = this.makePlayersEndGameViews(this.props.gamePlayerList, gameState, this.props.final)
    } else {
      this.props.gamePlayerList.forEach(player => {
        let pState = gameState.player_state[player.id]
        if (player.id === this.props.userId) {
          thisPlayerView = this.makePlayerStateActionView(player, pState)
        } else {
          playerViews.push( this.makePlayerStateView(player, pState) )
        }
      })
    }

    // --- 
    //let consumption = Math.ceil(gameState.derived.employment * settings.consumptionOverEmployment)
    let consumption = this.getConsumption(gameState)

    let investLevelRows = {}
    portNames.forEach((portId) => {
      investLevelRows[portId] = this.renderInvestLevelRows(portId)
    })

    let addVPs = this.state.input.actions?.UPDATE_VPS?.amount || 0
    
    let addInvestByLocation = {}
    let addBoatsByLocation = {}
    portNames.forEach(portId => {
      let action = `UPDATE_INVEST_${portId.toUpperCase()}`
      addInvestByLocation[portId] = this.state.input.actions?.[action]?.amount || 0
      addBoatsByLocation[portId] = this.state.input.actions?.['UPDATE_BOATS']?.[portId] || 0
    })

    // let grocerToSell = gameState.lastActiveMarket
    // if (gameState.foodPrice.w < gameState.foodPrice.e) grocerToSell = 'w'
    // if (gameState.foodPrice.e < gameState.foodPrice.w) grocerToSell = 'e'

    let grocerToSell = this.getGrocerToSell(gameState)

    let grocerClassW = ''
    let grocerClassE = ''
    if (grocerToSell == 'w') {
      grocerClassE = 'hidden'
    }
    if (grocerToSell == 'e') {
      grocerClassW = 'hidden'
    }

    // - boat animations - //
    let transitIds = portNames.concat(['buy'])
    let aeBoatSet = {}
    for (let portId of transitIds) {
      let fromPt = this.makePt(0, 0)
      let toPt = this.makePt(0, 0)
      switch (portId) {
        case 'nw':
          fromPt = this.makePt(0, 0)
          toPt = this.makePt(1, 1)
          break;
        case 'sw':
          fromPt = this.makePt(0, 0)
          toPt = this.makePt(1, 1)
          break;
        case 'ne':
          fromPt = this.makePt(1, 0)
          toPt = this.makePt(0, 1)
          break;
        case 'se':
          fromPt = this.makePt(1, 0)
          toPt = this.makePt(0, 1)
          break;
        case 'buy':
          fromPt = this.makePt(0, 0)
          toPt = this.makePt(0, 1)
          break;
      }

      let fromJSON = JSON.stringify(fromPt)
      let toJSON = JSON.stringify(toPt)

      let eles = []
      for (let player of this.props.gamePlayerList) {
        let eleId = `TOC_anim_boat_${portId}_${player.id}`
        eles.push(
          <div ref={this.animEle.boat[portId][player.id]} id={eleId} key={eleId} className='TOC_anim_ele' data-from-pt={ fromJSON } data-to-pt={ toJSON }>
            <BoatIcon className='TOC_icon' style={{'fill': `${player.color}`}} />&nbsp;{this.state.uiState.anim.boat[portId][player.id]}
          </div>
        )

      }
      aeBoatSet[portId] = (
        <>
          {eles}
        </>
      )
    }

    let cornersJSON = [[[],[]],[[],[]]]
    cornersJSON[0][0] = JSON.stringify({'x':0,'y':0})
    cornersJSON[0][1] = JSON.stringify({'x':0,'y':1})
    cornersJSON[1][0] = JSON.stringify({'x':1,'y':0})
    cornersJSON[1][1] = JSON.stringify({'x':1,'y':1})
    
    let playerNameEles = []
    let singleTest = null
    let titleItems = this.props.gamePlayerList.map(player => player)
    titleItems.push({
      color: '#ffffff',
      name: 'Run Ecconomy',
      id: 'run_ecconomy',
    })
    for (let player of titleItems) {
      let key = `player_name_${player.id}`
      let playerNameEle = <div ref={this.animEle.pop[key]} id={key} key={key} className='TOC_player_name TOC_hidden' style={{color: player.color}}>{player.name}</div>
      singleTest = playerNameEle
      playerNameEles.push(playerNameEle)
    }

    // TODO: make TOC_anim_ele a proper Class
    return (
      <div className='TOC_main_contain TOC_cols'>
        <MainColCP className='TOC_player_views' title='player states'>
          <div>
            {playerViews}
          </div>
          <div className='dsFooter'></div>
          <div>
            {thisPlayerView}
          </div>
        </MainColCP>
        <div className='main-col TOC_game_board main-col-untitled'>
          <div className='main-col-header'>
            <NotificationBarCP ref={this.noteCP}></NotificationBarCP>
          </div>
          <div className='main-col-content'>
            <div id='TOC_game_contain' className='TOC_rows'>
              
              <div id='TOC_low_anim_layer' className='TOC_anim_layer'>
                
              </div>

              <div className='TOC_game_row'>

                <div className='TOC_game_col TOC_rows'>
                  <div className='TOC_align_L'>
                    <div ref={this.animEle.pop.label_nw} style={{
                      'fontSize':'1.5em',
                      'marginLeft':'-0.5em',
                      'marginBottom': '0.5em',
                      'marginTop': '-0.5em',
                    }}>NW</div>
                    <div ref={this.animEle.pop.fish_nw} id="fish_NW"><FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> <AnimNumCP n={gameState.fishPopulation.nw} /></div>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '20%', right: '65%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_BR}
                    </div>
                  </div>

                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderBoatRows('nw')}
                      <div>
                        {this.makeIncrimentor(addBoatsByLocation['nw'], amount => {this.updateBoats(amount, 'nw')})}
                      </div>
                    </div>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '55%', right: '30%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_BR}
                    </div>
                  </div>

                  <div className='TOC_align_R TOC_abs_contain'>
                    <div className='TOC_abs_seg' style={{left: '130%', right: '-60%', bottom: '30%'}}>
                      {ArrowsComp_R}
                    </div>
                    <InventoryCP n={uiState.inventory.nw}> <FishIcon className='TOC_icon_small' style={{height: '0.8em'}} /></InventoryCP>
                    <div className='TOC_info_line'>
                      $<AnimNumCP n={gameState.fishPrice.nw} />/<FishIcon className='TOC_icon_small' style={{height: '0.8em'}} />
                    </div>
                    <AnchorIcon className='TOC_icon_large' />
                  </div>
                  <FenceIcon className='TOC_fence TOC_abs_right' />
                </div>


                <div className='TOC_game_col TOC_col_bg_gap TOC_rows' style={{justifyContent: 'end'}}>
                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderInvestRows('nw')}
                    </div>
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C TOC_rows'>
                    <div className='TOC_align_C'>
                      {investLevelRows['nw'].prodRows}
                    </div>
                    <div>
                      {this.makeIncrimentor(addInvestByLocation['nw'], amount => {this.updateInvest(amount, 'nw')})}
                    </div>
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C TOC_rows'>
                    {investLevelRows['nw'].marginRows}
                    <div ref={this.animEle.pop.invest_nw}>
                      <FactoryIcon className='TOC_icon_large' />
                    </div>
                  </div>
                  <FenceIcon className='TOC_fence TOC_abs_center' />
                </div>


                <div className='TOC_game_col TOC_rows' style={{width: '12em'}}>
                  <div className='TOC_align_C TOC_rows'>
                    <ArchIcon className='TOC_icon_large' />
                    <InventoryCP n={uiState.inventory.vp}> <ArchIcon className='TOC_icon_small' style={{height: '0.8em'}} /></InventoryCP>
                    <div className='TOC_align_C' style={{marginTop: '1.0em'}}>
                      <div ref={this.animEle.pop.vpPrice} className='TOC_align_L'>
                        {this.renderVPPrices()}
                      </div>
                    </div>

                    <div>
                      {this.makeIncrimentor(addVPs, amount => {this.updateVPs(amount)})}
                    </div>

                    <div className='TOC_align_C' style={{marginTop: '1.0em'}}>
                      <div className='TOC_align_L'>
                        {this.renderVPRows()}
                      </div>
                    </div>

                  </div>
                  <div className='TOC_align_C TOC_rows'>
                    <MersonIcon className='TOC_icon_large' />
                    <div>Employment: <AnimNumCP n={gameState.derived.employment} /></div>
                    <div>Consumption: <AnimNumCP n={consumption} /><CartIcon className='TOC_icon_small' /></div>
                  </div>
                </div>

                <div className='TOC_game_col TOC_col_bg_gap TOC_rows' style={{justifyContent: 'end'}}>
                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderInvestRows('ne')}
                    </div>
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C TOC_rows'>
                    <div className='TOC_align_C'>
                      {investLevelRows['ne'].prodRows}
                    </div>
                    <div>
                      {this.makeIncrimentor(addInvestByLocation['ne'], amount => {this.updateInvest(amount, 'ne')})}
                    </div>
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C TOC_rows'>
                    {investLevelRows['ne'].marginRows}
                    <div ref={this.animEle.pop.invest_ne}>
                      <FactoryIcon className='TOC_icon_large' />
                    </div>
                  </div>
                  <FenceIcon className='TOC_fence TOC_abs_center' />
                </div>

                <div className='TOC_game_col TOC_rows'>
                  <div className='TOC_align_R'>
                    <div ref={this.animEle.pop.label_ne} style={{
                      'fontSize':'1.5em',
                      'marginRight':'-0.5em',
                      'marginBottom': '0.5em',
                      'marginTop': '-0.5em',
                    }}>NE</div>
                    <div ref={this.animEle.pop.fish_ne} id="fish_NE"><FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> <AnimNumCP n={gameState.fishPopulation.ne} /></div>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '65%', right: '20%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_BL}
                    </div>
                  </div>

                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderBoatRows('ne')}
                      <div>
                        {this.makeIncrimentor(addBoatsByLocation['ne'], amount => {this.updateBoats(amount, 'ne')})}
                      </div>
                    </div>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '30%', right: '55%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_BL}
                    </div>
                  </div>

                  <div className='TOC_align_L TOC_abs_contain'>
                    <div className='TOC_abs_seg' style={{left: '-60%', right: '130%', bottom: '30%'}}>
                      {ArrowsComp_L}
                    </div>
                    <InventoryCP n={uiState.inventory.ne}> <FishIcon className='TOC_icon_small' style={{height: '0.8em'}} /></InventoryCP>
                    <div className='TOC_info_line'>
                      $<AnimNumCP n={gameState.fishPrice.ne} />/<FishIcon className='TOC_icon_small' style={{height: '0.8em'}} />
                    </div>
                    <AnchorIcon className='TOC_icon_large' />
                  </div>
                  <FenceIcon className='TOC_fence TOC_abs_left' />
                </div>

              </div>

              <div className='TOC_game_row'>

                <div className='TOC_game_col TOC_rows'>
                  <div className='TOC_align_R TOC_abs_contain'>
                    <div className='TOC_abs_seg' style={{left: '130%', right: '-60%', top: '30%'}}>
                      {ArrowsComp_R}
                    </div>
                    <AnchorIcon className='TOC_icon_large' />
                    <div className='TOC_info_line'>
                      $<AnimNumCP n={gameState.fishPrice.sw} />/<FishIcon className='TOC_icon_small' style={{height: '0.8em'}} />
                    </div>
                    <InventoryCP n={uiState.inventory.sw}> <FishIcon className='TOC_icon_small' style={{height: '0.8em'}} /></InventoryCP>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '55%', right: '30%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_TR}
                    </div>
                  </div>

                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderBoatRows('sw')}
                      <div>
                        {this.makeIncrimentor(addBoatsByLocation['sw'], amount => {this.updateBoats(amount, 'sw')})}
                      </div>
                    </div>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '20%', right: '65%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_TR}
                    </div>
                  </div>

                  <div className='TOC_align_L'>
                    <div ref={this.animEle.pop.fish_sw} id="fish_SW"><FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> <AnimNumCP n={gameState.fishPopulation.sw} /></div>
                    <div ref={this.animEle.pop.label_sw} style={{
                      'fontSize':'1.5em',
                      'marginLeft':'-0.5em',
                      'marginBottom': '-0.5em',
                      'marginTop': '0.5em',
                    }}>SW</div>
                  </div>
                </div>

                <div className='TOC_game_col TOC_col_bg_gap TOC_rows' style={{justifyContent: 'start'}}>
                  <div className='TOC_align_C TOC_rows'>
                    <div ref={this.animEle.pop.invest_sw}>
                      <FactoryIcon className='TOC_icon_large' />
                    </div>
                    {investLevelRows['sw'].marginRows}
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C TOC_rows'>
                    <div className='TOC_align_C'>
                      {investLevelRows['sw'].prodRows}
                    </div>
                    <div>
                      {this.makeIncrimentor(addInvestByLocation['sw'], amount => {this.updateInvest(amount, 'sw')})}
                    </div>
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderInvestRows('sw')}
                    </div>
                  </div>
                </div>

                <div className='TOC_game_col TOC_rows' style={{width: '12em'}}>
                  <div className='TOC_align_C TOC_abs_contain' style={{gap: '2.0em'}}>

                    <div className='TOC_abs_seg' style={{left: '-30%', right: '110%', top: '-30%', bottom: '100%'}}>
                      {ArrowsComp_BR}
                    </div>
                    <div className='TOC_abs_seg' style={{left: '-40%', right: '120%', bottom: '80%'}}>
                      {ArrowsComp_R}
                    </div>

                    <div className='TOC_abs_seg' style={{left: '110%', right: '-30%', top: '-30%', bottom: '100%'}}>
                      {ArrowsComp_BL}
                    </div>
                    <div className='TOC_abs_seg' style={{left: '120%', right: '-40%', bottom: '80%'}}>
                      {ArrowsComp_L}
                    </div>

                    <div className='TOC_align_C TOC_rows TOC_abs_contain'>
                      <div className={'TOC_abs_seg '+grocerClassW} style={{right: '50%', height: '1.5em', top: '-1.75em'}}>
                        {ArrowsComp_Up}
                      </div>
                      <div className='TOC_info_line'>Western</div>
                      <div className='TOC_info_line'>Provisions</div>
                      <CartIcon className='TOC_icon_large' />
                      <div>$<AnimNumCP n={gameState.foodPrice.w} /></div>
                      <InventoryCP n={uiState.inventory.w}> <CartIcon className='TOC_icon_small' /></InventoryCP>
                    </div>
                    
                    <div className='TOC_align_C TOC_rows TOC_abs_contain'>
                      <div className={'TOC_abs_seg '+grocerClassE} style={{left: '50%', height: '1.5em', top: '-1.75em'}}>
                        {ArrowsComp_Up}
                      </div>
                      <div className='TOC_info_line'>East Coast</div>
                      <div className='TOC_info_line'>Bodega</div>
                      <CartIcon className='TOC_icon_large TOC_reverse' />
                      <div>$<AnimNumCP n={gameState.foodPrice.e} /></div>
                      <InventoryCP n={uiState.inventory.e}> <CartIcon className='TOC_icon_small TOC_reverse' /></InventoryCP>
                    </div>
                  </div>
                  <div className='TOC_align_C TOC_rows'>
                    <BoatIcon className='TOC_icon_large' />
                    <InventoryCP n={uiState.inventory.boat}> <BoatIcon className='TOC_icon_small' style={{height: '0.8em'}} /></InventoryCP>
                    <div className='TOC_align_C' style={{marginTop: '1.0em'}}>
                      <div ref={this.animEle.pop.boatPrice} className='TOC_align_L'>
                        {this.renderBoatPrices()}
                      </div>
                    </div>
                    <div className='TOC_align_C' style={{marginTop: '1.0em', minHeight: '12.0em'}}>
                      <div className='TOC_align_L'>
                        <div>In Transit:</div>
                        {this.renderBoatTransitRows()}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='TOC_game_col TOC_col_bg_gap TOC_rows' style={{justifyContent: 'start'}}>
                  <div className='TOC_align_C TOC_rows'>
                    <div ref={this.animEle.pop.invest_se}>
                      <FactoryIcon className='TOC_icon_large' />
                    </div>
                    {investLevelRows['se'].marginRows}
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C TOC_rows'>
                    <div className='TOC_align_C'>
                      {investLevelRows['se'].prodRows}
                    </div>
                    <div>
                      {this.makeIncrimentor(addInvestByLocation['se'], amount => {this.updateInvest(amount, 'se')})}
                    </div>
                  </div>
                  <div className='TOC_gap_bg TOC_dashed_v_line'></div>
                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderInvestRows('se')}
                    </div>
                  </div>
                </div>

                <div className='TOC_game_col TOC_rows'>
                  <div className='TOC_align_L TOC_abs_contain'>
                    <div className='TOC_abs_seg' style={{left: '-60%', right: '130%', top: '30%'}}>
                      {ArrowsComp_L}
                    </div>
                    <AnchorIcon className='TOC_icon_large' />
                    <div className='TOC_info_line'>
                      $<AnimNumCP n={gameState.fishPrice.se} />/<FishIcon className='TOC_icon_small' style={{height: '0.8em'}} />
                    </div>
                    <InventoryCP n={uiState.inventory.se}> <FishIcon className='TOC_icon_small' style={{height: '0.8em'}} /></InventoryCP>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '30%', right: '55%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_TL}
                    </div>
                  </div>

                  <div className='TOC_align_C'>
                    <div className='TOC_align_L'>
                      {this.renderBoatRows('se')}
                      <div>
                        {this.makeIncrimentor(addBoatsByLocation['se'], amount => {this.updateBoats(amount, 'se')})}
                      </div>
                    </div>
                  </div>

                  <div className='TOC_col_gap_fill'>
                    <div className='TOC_abs_seg' style={{left: '65%', right: '20%', top: '30%', bottom: '30%'}}>
                      {ArrowsComp_TL}
                    </div>
                  </div>

                  <div className='TOC_align_R'>
                    <div ref={this.animEle.pop.fish_se} id="fish_SE"><FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> <AnimNumCP n={gameState.fishPopulation.se} /></div>
                    <div ref={this.animEle.pop.label_se} style={{
                      'fontSize':'1.5em',
                      'marginRight':'-0.5em',
                      'marginBottom': '-0.5em',
                      'marginTop': '0.5em',
                    }}>SE</div>
                  </div>
                </div>

              </div>

              <div id='TOC_high_anim_layer' className='TOC_anim_layer'>
                {/* fish animations */}
                <div id='TOC_anim_path_fish_NW' className='TOC_anim_path'>
                  <div ref={this.animEle.fish.nw} id='TOC_anim_fish_NW' className='TOC_anim_ele' data-from-pt={ cornersJSON[0][0] } data-to-pt={ cornersJSON[1][1] }>
                    <FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> {uiState.anim.fish.nw}
                  </div>
                </div>

                <div id='TOC_anim_path_fish_SW' className='TOC_anim_path'>
                  <div ref={this.animEle.fish.sw} id='TOC_anim_fish_SW' className='TOC_anim_ele' data-from-pt={ cornersJSON[0][1] } data-to-pt={ cornersJSON[1][0] }>
                    <FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> {uiState.anim.fish.sw}
                  </div>
                </div>

                <div id='TOC_anim_path_fish_NE' className='TOC_anim_path'>
                  <div ref={this.animEle.fish.ne} id='TOC_anim_fish_NE' className='TOC_anim_ele' data-from-pt={ cornersJSON[1][0] } data-to-pt={ cornersJSON[0][1] }>
                    <FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> {uiState.anim.fish.ne}
                  </div>
                </div>

                <div id='TOC_anim_path_fish_SE' className='TOC_anim_path'>
                  <div ref={this.animEle.fish.se} id='TOC_anim_fish_SE' className='TOC_anim_ele' data-from-pt={ cornersJSON[1][1] } data-to-pt={ cornersJSON[0][0] }>
                    <FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> {uiState.anim.fish.se}
                  </div>
                </div>
                {/* production animations */}
                <div id='TOC_anim_path_prod_NW' className='TOC_anim_path_prod'>
                  <div ref={this.animEle.prod.nw} id='TOC_anim_prod_NW' className='TOC_anim_ele TOC_show_fish' data-from-pt={ cornersJSON[0][0] } data-to-pt={ cornersJSON[1][1] }>
                    <CartIcon className='TOC_icon' />
                    <FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> {uiState.anim.prod.nw}
                  </div>
                </div>

                <div id='TOC_anim_path_prod_SW' className='TOC_anim_path_prod'>
                  <div ref={this.animEle.prod.sw} id='TOC_anim_prod_SW' className='TOC_anim_ele TOC_show_fish' data-from-pt={ cornersJSON[0][0] } data-to-pt={ cornersJSON[1][1] }>
                    <CartIcon className='TOC_icon' />
                    <FishIcon className='TOC_icon' style={{'height': '1.5em'}} /> {uiState.anim.prod.sw}
                  </div>
                </div>

                <div id='TOC_anim_path_prod_NE' className='TOC_anim_path_prod'>
                  <div ref={this.animEle.prod.ne} id='TOC_anim_prod_NE' className='TOC_anim_ele TOC_show_fish' data-from-pt={ cornersJSON[1][0] } data-to-pt={ cornersJSON[0][1] }>
                    <CartIcon className='TOC_icon TOC_reverse' />
                    <FishIcon className='TOC_icon TOC_reverse' style={{'height': '1.5em'}} /> {uiState.anim.prod.ne}
                  </div>
                </div>

                <div id='TOC_anim_path_prod_SE' className='TOC_anim_path_prod'>
                  <div ref={this.animEle.prod.se} id='TOC_anim_prod_SE' className='TOC_anim_ele TOC_show_fish' data-from-pt={ cornersJSON[1][0] } data-to-pt={ cornersJSON[0][1] }>
                    <CartIcon className='TOC_icon TOC_reverse' />
                    <FishIcon className='TOC_icon TOC_reverse' style={{'height': '1.5em'}} /> {uiState.anim.prod.se}
                  </div>
                </div>
                {/* consume animations */}
                <div id='TOC_anim_path_cons_W' className='TOC_anim_path'>
                  <div ref={this.animEle.cons.w} id='TOC_anim_cons_W' className='TOC_anim_ele' data-from-pt={ cornersJSON[0][1] } data-to-pt={ cornersJSON[0][0] }>
                    <CartIcon className='TOC_icon' /> {uiState.anim.consumption}
                  </div>
                </div>

                <div id='TOC_anim_path_cons_E' className='TOC_anim_path'>
                  <div ref={this.animEle.cons.e} id='TOC_anim_cons_E' className='TOC_anim_ele' data-from-pt={ cornersJSON[0][1] } data-to-pt={ cornersJSON[0][0] }>
                    <CartIcon className='TOC_icon TOC_reverse' /> {uiState.anim.consumption}
                  </div>
                </div>

                {/* boat animations */}

                <div id='TOC_anim_path_boat_NW' className='TOC_anim_path'>
                  {aeBoatSet['nw']}
                </div>

                <div id='TOC_anim_path_boat_SW' className='TOC_anim_path'>
                  {aeBoatSet['sw']}
                </div>

                <div id='TOC_anim_path_boat_NE' className='TOC_anim_path'>
                  {aeBoatSet['ne']}
                </div>

                <div id='TOC_anim_path_boat_SE' className='TOC_anim_path'>
                  {aeBoatSet['se']}
                </div>

                <div id='TOC_anim_path_boat_BUY' className='TOC_anim_path'>
                  {aeBoatSet['buy']}
                </div>
                {/* player name animations */}
                
                {playerNameEles}
                
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }


  // --- animations --- //

  displayMessage (mess) {
    this.noteCP.current.notify(mess)
  }

  makePlayerMessage (player, count, IconCP, addnlText='') {
    let sign = ''
    if (count > 0) sign = '+'
    let message = <>
      <span style={{'color': `${player.color}`}}>{player.name}</span>, {addnlText} {sign}{count}<IconCP className='TOC_icon_small' style={{'fill': `${player.color}`}} />
    </>
    return message
  }

  // TODO: formalize this. TypeScript anyone?
  makePt (x, y) {
    return {x, y}
  }

  // invertPt (pt) {
  //   return makePt(1-pt.x, 1-pt.y)
  // }

  makeBumpTL (lambda) {
    let tl = AnimateState.makeTimeline()
    tl.onSetToPost = () => {
      lambda()
    }
    return tl
  }

  makeStateBumpTL (stateLambda) {
    return this.makeBumpTL(() => {this.setState(stateLambda)})
  }

  // Maybe add option for X ease and Y ease
  makePathAnim (ele, isReturn = false) { // fromPt and toPt are 2D points. TypeScript anyone? 
    let tl = AnimateState.makeTimeline()
    tl.checkMarkers(0, 1)

    tl.onInit = () => {
      ele.current.style.display = 'unset'
    }
    tl.onDeInit = () => {
      ele.current.style.display = 'none'
    }

    let fromPt = ele.current.dataset.fromPt
    let toPt = ele.current.dataset.toPt
    if (isReturn) {
      fromPt = ele.current.dataset.toPt
      toPt = ele.current.dataset.fromPt
    }
    fromPt = JSON.parse(fromPt)
    toPt = JSON.parse(toPt)

    tl.onFrame = (pct) => {
      let easePct = boatMoveEase(pct)
      let xPct = Utils.lerp(fromPt.x, toPt.x, easePct)
      let yPct = Utils.lerp(fromPt.y, toPt.y, easePct)
      let xPctTxt = (xPct * 100) + '%'
      let yPctTxt = (yPct * 100) + '%'
      ele.current.style.top = yPctTxt
      ele.current.style.left = xPctTxt
    }

    return tl
  }

  makeItemMoveAnim (ele, onStart, onEnd, isReturn = false) {
    let tl = this.makePathAnim(ele, isReturn)

    let tl0 = AnimateState.makeTimeline()

    // maybe put the move tl in a parent TL so we can set the init val
    tl0.onSetToPost = () => {
      onStart()
    }
    tl.addChild(tl0, 0.001, 0.001) // TODO: fix this, should work as expected with 0

    tl.onSetToPost = () => {
      onEnd()
    }

    return tl
  }


  makeFishAnim (portId, moveCount, sourceCount, destCount) {
    // sourceCount and destCount are for the new state at the source and destination 
    //   transit count is set in the render function and tied to gameState.lastActiveBoats[portId]
    //   I'm thinking that should change and be set here?
    let ele = this.animEle.fish[portId]

    let startMess = <>
      {portId} fish population: -{moveCount}<FishIcon className='TOC_icon_small' />
    </>

    let endMess = <>
      {portId} fish market: +{moveCount}<FishIcon className='TOC_icon_small' />
    </>

    // maybe put the move tl in a parent TL so we can set the init val
    let onStart = () => {
      // set the transit count
      //   transit count is set in the render function and tied to gameState.lastActiveBoats[portId]
      //   I'm thinking that should change and be set here?
      // and change source count
      this.displayMessage(startMess)
      this.setState((state) => {
        //state.gameState.lastActiveBoats[portId] = moveCount // NOPE
        state.gameState.fishPopulation[portId] = sourceCount
        state.uiState.anim.fish[portId] = moveCount
        return state
      })
    }

    let onEnd = () => {
      this.displayMessage(endMess)
      this.setState((state) => {
        state.uiState.inventory[portId] = destCount
        return state
      })
    }

    let tl = this.makeItemMoveAnim(ele, onStart, onEnd)

    return tl
  }


  makeProdAnim (portId, moveCount, sourceCount, destCount) {
    let marketId = this.getMarketForPort(portId)
    let ele = this.animEle.prod[portId]
    
    let startMess = <>
      {portId} fish market: -{moveCount}<FishIcon className='TOC_icon_small' />
    </>

    let endMess = <>
      {marketId} grocery market: +{moveCount}<CartIcon className='TOC_icon_small' />
    </>

    let onStart = () => {
      this.displayMessage(startMess)
      this.setState((state) => {
        //state.gameState.derived.stocksInPlay[portId] = moveCount
        state.uiState.anim.prod[portId] = moveCount
        state.uiState.inventory[portId] = sourceCount
        return state
      })
    }

    let onEnd = () => {
      this.displayMessage(endMess)
      this.setState((state) => {
        state.uiState.inventory[marketId] = destCount
        return state
      })
    }

    let tl = this.makeItemMoveAnim(ele, onStart, onEnd)

    let tlIcon = AnimateState.makeTimeline()
    tlIcon.onSetToPre = () => {
      ele.current.classList.remove('TOC_show_cart')
      ele.current.classList.add('TOC_show_fish')
    }
    tlIcon.onSetToPost = () => {
      ele.current.classList.remove('TOC_show_fish')
      ele.current.classList.add('TOC_show_cart')
    }

    tl.addChild(tlIcon, 0.42, 0.42)

    return tl
  }


  makeConsAnim (marketId, consumption, marketCount) {
    let ele = this.animEle.cons[marketId]
    
    let startMess = <>
      {marketId} grocery market: -{consumption}<CartIcon className='TOC_icon_small' />
    </>

    let onStart = () => {
      this.displayMessage(startMess)
      this.setState((state) => {
        state.uiState.inventory[marketId] = marketCount
        state.uiState.anim.consumption = consumption
        return state
      })
    }

    let onEnd = () => {}

    let tl = this.makeItemMoveAnim(ele, onStart, onEnd)

    return tl
  }

  // TODO: moveCount ?
  makeBoatAnim (playerId, portId, boatCount, portCount, marinaCount, isReturn = false) {
    let ele = this.animEle.boat[portId][playerId]

    // TODO: clean up start and end functions
    let onStart = () => {}
    let player = this.playerDict[playerId]
    let portText = portId.toUpperCase()
    let isPos = isReturn
    let sign = ''
    if (portText === 'BUY'){
      if (isReturn) portText = 'SELL'
    } else {
      sign = '-'
      if (isReturn) sign = '+'
    }
    let message = <>
      <span style={{'color': `${player.color}`}}>{player.name}</span>, {portText} {sign}{boatCount}<BoatIcon className='TOC_icon_small' style={{'fill': `${player.color}`}} />
    </>

    onStart = () => {
      this.setState((state) => {
        if (portId !== 'buy') {
          state.gameState.player_state[playerId].boatsByLocation[portId] = portCount
        } else {
          state.uiState.inventory.boat = portCount
        }
        return state
      })
    }
    
    let onEnd = () => {
      this.setState((state) => {
        state.uiState.marina[playerId] = marinaCount
        return state
      })
    }

    if (isReturn) {
      let holder = onStart
      onStart = onEnd
      onEnd = holder
    }

    let tl = this.makeItemMoveAnim(ele, onStart, onEnd, isReturn)
    // and stuff that is ALWAYS on start
    tl.addChild( this.makeBumpTL(() => {
      this.displayMessage(message)
      this.setState((state) => {
        state.uiState.anim.boat[portId][playerId] = boatCount
        return state
      })
    }), 0.001, 0.001) // TODO: fix this, should work as expected with 0

    return tl
  }

  makePopAnim (ele, anchorX=0.5, anchorY=0.5) {
    let popScale = 2.5
    let tl = AnimateState.makeTimeline()
    
    tl.onInit = () => {
      if (ele?.current) ele.current.style.transformOrigin = `${anchorX*100}% ${anchorY*100}%`
    }

    tl.onFrame = (pct) => {
      if (ele?.current) {
        let a = 1-pct
        a = a * a
        let scalePct = (a * (1-a)) * 4
        scalePct = Math.pow(scalePct, 0.07) 
        let scale = Utils.lerp(1, popScale, scalePct)
        ele.current.style.transform = `scale(${scale})`
      }
    }
    
    return tl
  }

  // TODO animateStateChange(toState) for replaying state animation
  animateStateChange (state0, state1) {
    // durrations
    let durMult = 2 //0.3 //3

    let bumpDelay = 750
    let bumpDelaySm = 400
    let popDur = 500
    let moveDur = 2000
    let buyBoatDur = moveDur / 3

    // - //
    let t = 0
    let animCtrl = AnimateState.makeAnimationController()
    let animTL = animCtrl.timeline
    //animCtrl.setAnimationToPercent(0.0)

    // - boilerplate reducers -
    let addBumpTL = (lambda) => { // I still think t should be a function argument
      animTL.addChild( this.makeBumpTL(lambda), t, t)
    }

    let addStateBumpTL = (stateLambda) => {
      animTL.addChild( this.makeStateBumpTL(stateLambda), t, t)
    }

    let addPopTL = (ele, anchorX=0.5, anchorY=0.5) => {
      let tl = this.makePopAnim(ele, anchorX, anchorY)
      animTL.addChild(tl, t, t+popDur)
    }

    let getAnchorByPort = (portId) => {
      let anchorX = 0.0
      let anchorY = 0.0
      if (portId === 'sw' || portId === 'se') {
        anchorY = 1.0
      }
      if (portId === 'ne' || portId === 'se') {
        anchorX = 1.25 // should be 1.0 for labels
      }
      return {anchorX, anchorY}
    }

    let addFishPopTL = (portId) => {
      let {anchorX, anchorY} = getAnchorByPort(portId)
      let key = `fish_${portId}`
      return addPopTL(this.animEle.pop[key], anchorX, anchorY)
    }

    let addPortLabelPopTL = (portId) => {
      let {anchorX, anchorY} = getAnchorByPort(portId)
      let key = `label_${portId}`
      return addPopTL(this.animEle.pop[key], anchorX, anchorY)
    }

    let addPopHideTL = (ele, anchorX=0.5, anchorY=0.5) => {
      let tl = this.makePopAnim(ele, anchorX, anchorY)
      tl.onInit = () => {
        ele.current.classList.remove('TOC_hidden')
      }
      tl.onDeInit = () => {
        ele.current.classList.add('TOC_hidden')
      }
      animTL.addChild(tl, t, t+popDur)
    }

    // TODO: remove preAnimUiState (an any reference to this.state) 
    //  in favor of a running UI State (like for inventory numbers that change via the aimation)
    //let preAnimUiState = JSON.parse( JSON.stringify(this.state.uiState) )
    // TODO: repeat code between runningState and this.state initializer 
    let marina = {}
    for (let player of this.props.gamePlayerList) {
      marina[player.id] = 0
    }

    let runningState = JSON.parse( JSON.stringify(state0) )
    runningState.uiState = {
      inventory: {
        'w': 0,
        'e': 0,
        'nw': 0,
        'sw': 0,
        'ne': 0,
        'se': 0,
        'vp': 0,
        'boat': 0,
      }, 
      marina: marina, 
    }

    // - set to start state - //
    addStateBumpTL((state) => {
      state.gameState = state0
      // turn interaction off
      state.isAnimating = true
      this.displayMessage(`execute player orders`)
      return state
    })
    t += bumpDelay

    // - player update A - //
    for (let player of this.props.gamePlayerList) {
      let plState0 = state0.player_state[player.id]
      let plState1 = state1.player_state[player.id]
      
      let playerNameKey = `player_name_${player.id}`
      addPopHideTL(this.animEle.pop[playerNameKey])
      t += bumpDelaySm

      // VP change
      if (plState0.vpCount !== plState1.vpCount) {
        let vpDif = plState1.vpCount - plState0.vpCount
        let vpCost = this.getVPCost(vpDif, state0.derived.vpsInPlay)
        runningState.uiState.inventory.vp -= vpDif
        let vpInventory = runningState.uiState.inventory.vp // check this, it may be needed for scope reasons, maybe not

        let message = this.makePlayerMessage(player, vpDif, ArchIcon)
        addStateBumpTL((state) => {
          state.gameState.player_state[player.id].vpCount = plState1.vpCount
          state.uiState.inventory.vp = vpInventory
          this.displayMessage(message)
          return state
        })

        let playerVPKey = `vp_${player.id}`
        addPopTL(this.animEle.pop[playerVPKey])

        t += bumpDelaySm

        let playerMoney = runningState.player_state[player.id].money -= vpCost
        addStateBumpTL((state) => {
          state.gameState.player_state[player.id].money = playerMoney
          return state
        })
        t += bumpDelay
      }

      // boats to marina
      // TODO: boatChange here is actually boatsToSell which is -boatChange
      let boatChange = 0
      let didBoatMove = false
      for (let portId of portNames) {
        let boatCount = plState0.boatsByLocation[portId] - plState1.boatsByLocation[portId]
        boatChange += boatCount // +s and -s will cancel out such that a buy or sell may not be needed
        if (boatCount > 0) {
          didBoatMove = true
          // boat animation 
          runningState.uiState.marina[player.id] += boatCount
          let boatTL = this.makeBoatAnim(player.id, portId, boatCount, plState1.boatsByLocation[portId], runningState.uiState.marina[player.id])
          animTL.addChild( boatTL, t, t+moveDur)
          t += bumpDelay
        }
      }
      if (didBoatMove) t += moveDur

      // boats change
      if (boatChange !== 0) {
        let isSell = (boatChange > 0)
        runningState.uiState.marina[player.id] -= boatChange
        runningState.uiState.inventory.boat += boatChange
        let boatTL = this.makeBoatAnim(player.id, 'buy', Math.abs(boatChange), runningState.uiState.inventory.boat, runningState.uiState.marina[player.id], isSell)
        animTL.addChild( boatTL, t, t+buyBoatDur)
        t += buyBoatDur
        // money from selling / buying boats
        let boatCost = this.getBoatCost(-boatChange, state0.derived.boatsInPlay)
        let playerMoney = runningState.player_state[player.id].money -= boatCost
        addStateBumpTL((state) => {
          state.gameState.player_state[player.id].money = playerMoney
          return state
        })
        t += bumpDelay
      }

      // invest change
      for (let portId of portNames) {
        let investDif = plState1.investByLocation[portId] - plState0.investByLocation[portId]
        if (investDif !== 0) {
          let investCost = this.getInvestCost(portId, investDif, state0.derived.stocksInPlay[portId])
          let portStock = runningState.derived.stocksInPlay[portId] += investDif
          let message = this.makePlayerMessage(player, investDif, StockIcon)
          addStateBumpTL((state) => {
            state.gameState.player_state[player.id].investByLocation[portId] = plState1.investByLocation[portId]
            state.gameState.derived.stocksInPlay[portId] = portStock 
            this.displayMessage(message)
            return state
          })
          let playerIconKey = `invest_${portId}_${player.id}`
          addPopTL(this.animEle.pop[playerIconKey])

          let investKey = `investPrice_${portId}`
          addPopTL(this.animEle.pop[investKey])

          t += bumpDelaySm
  
          let playerMoney = runningState.player_state[player.id].money -= investCost
          addStateBumpTL((state) => {
            state.gameState.player_state[player.id].money = playerMoney
            return state
          })
          t += bumpDelay
        }
      }
      // hard update just to be sure?
      // addStateBumpTL((state) => {
      //   state.gameState.derived.stocksInPlay = state1.derived.stocksInPlay
      //   return state
      // })

    } // end by player

    // - run economy - //
    // TODO: add run economy notification (so make a non-state addBump function)
    addPopHideTL(this.animEle.pop['player_name_run_ecconomy'])
    addBumpTL(() => {
      this.displayMessage(`run the economy`)
    })
    t += bumpDelay

    for (let portId of portNames) {
      addPortLabelPopTL(portId)
      t += bumpDelaySm

      let isReverseOrder = false
      if (portId === 'sw' || portId === 'se') isReverseOrder = true
      // fishing
      let activeBoats = sumObject(state1.lastActiveBoats[portId])
      if (activeBoats !== 0) {
        let sourceCount = state0.fishPopulation[portId] - activeBoats
        runningState.fishPopulation[portId] = sourceCount
        runningState.uiState.inventory[portId] += activeBoats
        let fishingTL = this.makeFishAnim(portId, activeBoats, sourceCount, runningState.uiState.inventory[portId])
        animTL.addChild( fishingTL, t, t+moveDur)
        addFishPopTL(portId)

        let playersInList = []
        for (let player of this.props.gamePlayerList) {
          let playerBoatCount = state1.lastActiveBoats[portId][player.id]
          if (playerBoatCount !== 0) {
            if (isReverseOrder) {
              playersInList.unshift(player)
            } else {
              playersInList.push(player)
            }
          }
        }

        // add-money animations live in the middle of this animation
        let nextT = t+moveDur+bumpDelay
        t += (moveDur*0.5)-(bumpDelaySm * (playersInList.length-1))

        let fishPrice = state0.fishPrice[portId]
        for (let player of playersInList) {
          let playerBoatCount = state1.lastActiveBoats[portId][player.id]
          // only players where if (playerBoatCount !== 0)
          let playerGain = playerBoatCount * fishPrice
          let playerMoney = runningState.player_state[player.id].money += playerGain
          addStateBumpTL((state) => {
            // TODO: add player boat icon bump
            state.gameState.player_state[player.id].money = playerMoney
            return state
          })

          let key = `boat_${portId}_${player.id}`
          addPopTL(this.animEle.pop[key])

          t += bumpDelaySm
          
        }
        t = nextT
      }

      // production
      let shareCount = state1.derived.stocksInPlay[portId] // NEW (this turn's) share count!!!
      let prodUnits = this.props.settings.investTable[shareCount].production
      let moneyPerUnit = this.getDollarPerUnit(portId)
      if (moneyPerUnit > 0 && prodUnits > 0) {
        let unitPerShare = this.unitPerShareByIndex(shareCount)
        let moneyPerShare = moneyPerUnit * unitPerShare
        
        let marketId = this.getMarketForPort(portId)
        runningState.uiState.inventory[portId] -= prodUnits
        runningState.uiState.inventory[marketId] += prodUnits

        let prodTL = this.makeProdAnim(portId, prodUnits, runningState.uiState.inventory[portId], runningState.uiState.inventory[marketId])
        animTL.addChild( prodTL, t, t+moveDur)
        // add-money animations live in the middle of this animation
        let nextT = t+moveDur+bumpDelay
        let midT = t + (moveDur*0.5)
        t += (moveDur*0.5)-bumpDelaySm

        for (let player of this.props.gamePlayerList) {
          let playerShareCount = state1.player_state[player.id].investByLocation[portId]
          if (playerShareCount !== 0) {
            let playerGain = playerShareCount * moneyPerShare
            let playerMoney = runningState.player_state[player.id].money += playerGain
            addStateBumpTL((state) => {
              // TODO: bump invest icon
              state.gameState.player_state[player.id].money = playerMoney
              return state
            })
            let key = `invest_${portId}_${player.id}`
            addPopTL(this.animEle.pop[key])
            t += bumpDelaySm
          }
        }

        if (prodUnits > 0) {
          t = midT
          let key = `invest_${portId}`
          addPopTL(this.animEle.pop[key])
        }

        t = nextT
      }

    }

    // consumption and employment are from NEW state (like production and fishing)
    // consumption
    let marketId = this.getGrocerToSell(state0)
    let consumption = this.getConsumption(state0)
    runningState.uiState.inventory[marketId] -= consumption

    let consTL = this.makeConsAnim(marketId, consumption, runningState.uiState.inventory[marketId])
    animTL.addChild(consTL, t, t+buyBoatDur)
    t += buyBoatDur + bumpDelay
    
    // - price update - //
    // employment 
    addStateBumpTL((state) => {
      state.gameState.derived.employment = state1.derived.employment
      return state
    })
    t += bumpDelay

    // grocery stock
    for (let marketId of ['w', 'e']) {
      let priceDiff = state1.foodPrice[marketId] - state0.foodPrice[marketId]
      let sign = '+'
      if (priceDiff < 0) sign = '-'
      priceDiff = Math.abs(priceDiff)
      addStateBumpTL((state) => {
        this.displayMessage(`${marketId} grocery market ${sign}$${priceDiff}`)
        state.uiState.inventory[marketId] = 0
        state.gameState.foodPrice[marketId] = state1.foodPrice[marketId]
        return state
      })
      t += bumpDelay
    }

    // by port
    for (let portId of portNames) {
      // stock price
      // addStateBumpTL((state) => {
      //   state.uiState.inventory[portId] = 0
      //   state.gameState.foodPrice[portId] = state1.foodPrice[portId]
      //   return state
      // })
      // t += bumpDelay
      
      // fish price
      let priceDiff = state1.fishPrice[portId] - state0.fishPrice[portId]
      let sign = '+'
      if (priceDiff < 0) sign = '-'
      priceDiff = Math.abs(priceDiff)
      addStateBumpTL((state) => {
        this.displayMessage(`${portId} fish market ${sign}$${priceDiff}`)
        state.uiState.inventory[portId] = 0
        state.gameState.fishPrice[portId] = state1.fishPrice[portId]
        return state
      })
      t += bumpDelay

      // fish population
      let popDiff = state1.fishPopulation[portId] - runningState.fishPopulation[portId]
      let popMess = <>
        {portId} fish population: +{popDiff}<FishIcon className='TOC_icon_small' />
      </>
      addStateBumpTL((state) => {
        this.displayMessage(popMess)
        state.gameState.fishPopulation[portId] = state1.fishPopulation[portId]
        return state
      })
      // let anchorX = 0.0
      // let anchorY = 0.0
      // if (portId === 'sw' || portId === 'se') {
      //   anchorY = 1.0
      // }
      // if (portId === 'ne' || portId === 'se') {
      //   anchorX = 1.25
      // }
      // let key = `fish_${portId}`
      // addPopTL(this.animEle.pop[key], anchorX, anchorY)
      addFishPopTL(portId)
      t += bumpDelay

    }

    // VP price
    if (state1.derived.vpsInPlay !== state0.derived.vpsInPlay) {
      addStateBumpTL((state) => {
        // TODO: we need an animation of the UI and a more detailed message
        this.displayMessage(`VP price adjust`)
        state.gameState.derived.vpsInPlay = state1.derived.vpsInPlay
        state.uiState.inventory.vp = 0
        return state
      })
      addPopTL(this.animEle.pop.vpPrice)
      t += bumpDelay
    }

    // boat price
    if (state1.derived.boatsInPlay !== state0.derived.boatsInPlay) {
      addStateBumpTL((state) => {
        // TODO: we need an animation of the UI and a more detailed message
        this.displayMessage(`boat price adjust`)
        state.gameState.derived.boatsInPlay = state1.derived.boatsInPlay
        state.uiState.inventory.boat = 0
        return state
      })

      //let boatPricePopTL = this.makePopAnim(this.animEle.pop.boatPrice)
      //animTL.addChild( boatPricePopTL, t, t+popDur)
      addPopTL(this.animEle.pop.boatPrice)
      t += bumpDelay
    }

    // - player update B - //
    for (let player of this.props.gamePlayerList) {
      let plState0 = state0.player_state[player.id]
      let plState1 = state1.player_state[player.id]
      // boats out to fish
      let didBoatMove = false
      for (let portId of portNames) {
        let boatCount = plState1.boatsByLocation[portId] - plState0.boatsByLocation[portId]
        if (boatCount > 0) {
          didBoatMove = true
          // boat animation 
          runningState.uiState.marina[player.id] -= boatCount
          let boatTL = this.makeBoatAnim(player.id, portId, boatCount, plState1.boatsByLocation[portId], runningState.uiState.marina[player.id], true)
          animTL.addChild( boatTL, t, t+moveDur)
          t += bumpDelay
        }
      }
      if (didBoatMove) t += moveDur
    }

    // did we miss anything?
    // this.setUIToState()
    addStateBumpTL((state) => {
      state.gameState = state1
      // turn interaction back on
      state.isAnimating = false
      return state
    })   

    // preAnimUiState
    // ? TODO: add to timeline at 0 ?
    // this.setState((state) => {
    //   state.uiState = preAnimUiState
    //   return state
    // })
    
    // set duration
    animCtrl.setDuration(t * durMult)

    // run it
    //this.setCanUserEdit(false)
    animCtrl.runFromBeginning()
    //animCtrl.run()
  }

  //deriveNewState () {
    // figure out how many boats are fishing durring economy phase 
    //this.props.gameState
  //}

  componentDidUpdate (prevProps/*, prevState*/) {
    // on new round clear user actions from previous round
    //  and animate the state changes
    //this.setCanUserEdit(false)
    if (prevProps?.gameState?.roundCount !== this.props?.gameState?.roundCount) {
      this.resetInputState()
      let state1 = this.props.gameState
      let state0 = prevProps?.gameState
      if (!state0) state0 = state1
      this.animateStateChange(state0, state1)
    }// else {
    //  this.setCanUserEdit(true)
    //}
  }

  // for testing
  testAnim = () => {
    let lastI = this.props.stateDiffs.length - 1
    let [state0, state1] = getStatesFromDiffs(this.props.initState, this.props.stateDiffs, [lastI-1, lastI])
    console.log({state0, state1})
    this.animateStateChange(state0, state1)
  }

  testPop = () => {
    let tl = this.makePopAnim(this.animEle.pop.fish_se, 1.2, 1.0)
    let animCtrl = AnimateState.makeAnimationController()
    animCtrl.timeline = tl
    animCtrl.setDuration(500) // Be sure to align with popDur
    animCtrl.runFromBeginning()
  }
}



const mapStateToProps = (state) => {
  return {
    userId: state.user?.user?.id,
    settings: state.game.gameState.settings,
    //game: state.game,
    gameState: state.game.gameState.current_state,
    gamePlayerList: GameSelectors.getGamePlayerList(state),
    initState: state.game.gameState.init_state,
    final: state.game.gameState.final,
    isGameOver: Boolean(Object.values(state.game.gameState.final).length),
    stateDiffs: state.game.gameState.state_change_history, // For testing, delete this <-----------------<<<
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    submitMove: (action) => dispatch(GameActions.submitMove(action))
  }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(TragedyOfTheCommons_CP)
